export enum ActiveLinkType {
  SequenceEntry = 'sequenceEntry',
  ConfirmOrder = 'confirmOrder',
  SpecificationsAndShipping = 'SpecificationsAndShipping',
  ReviewPage = 'reviewPage',
  MultipleEntry = 'multipleEntry',
}

export enum TubeProduct {
  StandardOld = 'standard-old',
  Standard = 'standard',
  Rna = 'rna',
  RnaOld = 'rna-old',
  Aqua = 'aqua',
  Wellred = 'wellred',
  WellredOld = 'wellred-old',
  Probe = 'PROBE',
  ProbeOld = 'probe-old',
  Cpeptide = 'cpeptide',
  Beacon = 'BEACON',
  BeaconOld = 'BEACON-old',
  EasyOligo = 'easyoligo',
  EasyOligoOld = 'easyoligo-old',
  PureSimple = 'puresimple',
  PureSimpleOld = 'puresimple-old',
  LongOligo = 'longoligo',
  LongOligoOld = 'longoligo-old',
  iscaledna = 'iscaledna',
  iscalednaOld = 'iscaledna-old',
  mirna = 'mirna',
  mirnaOld = 'mirna-old',
}

export enum TubeProperties {
  Quote = 'QUOTE',
  EasyOligo = 'easyoligo',
  Amount = 'amount',
  Scale = 'scale',
  Purification = 'purification',
  LoggedInUser = 'LoggedInUser',
  SEQUENCE_API_TIME = 1000,
  Concentration = 'concentration',
  Format = 'format',
  None = 'None',
  Continue = 'continue',
  AddOligo = 'addOligo',
  DefaultNTerminal = '[H]',
  DefaultCTerminal = '[OH]',
  Shipping = 'shipping',
  ErrorUrl = 'https://www.sigmaaldrich.com/webapp/wcs/stores/servlet/UserRegNavigation?storeId=11001',
  Quantitation = 'quantitation',
  PurityLevel = 'purityLevel',
  Success = 'success',
  Panel1 = 'panel1',
  Panel2 = 'panel2',
  Panel3 = 'panel3',
  Panel4 = 'panel4',
  PriceHeaderError = 'priceHeaderError',
  RequiredField = 'Required Field',
  ReviewError = 'ReviewError',
  SelectionRequired = 'Selection Required',
  SelectionRequiredError = '選択が必要',
  LabeledAminoAcidRequired = 'Select a labeled amino acid',
  ConjugationAmount = 'conjugationAmount',
  Conjugation = 'conjugation',
  ConjugationChemistry = 'conjugationChemistry',
  RequiredFieldError = '入力必須項目',
  UnAuthorized = 'UnAuthorized',
  InvalidProduct = 'DEeP Configurator not enabled for country',
  ProductNotValid = 'Invalid Product',
  UserCannotOrder = 'User cannot place the Order',
  TradeMarkURL = '/life-science/legal/product-licenses/oligonucleotide-label-licenses',
  ModificationsTechnicalResourceURL = '/technical-documents/technical-article/genomics/qpcr/custom-dna-oligos-modifications ',
  email = 'dnaoligos@milliporesigma.com',
  cpeptideEmail = 'isrcustserv@merckgroup.com',
  cpeptideJPEmail = 'jpts@merckgroup.com',
  tubes = 'tubes',
  quantitation = 'quantitation',
  conjugation = 'conjugation',
  conjugationAmount = 'conjugationAmount',
  conjugationChemistry = 'conjugationChemistry',
  additionalCarrierProtein = 'additionalCarrierProtein',
  MaximumOligosAllowed = 200,
  MaximumOligosAllowedIscaledna = 100,
  OTHER = 'OTHER',
  DRY = 'DRY',
  LIQUID = 'LIQUID',
  AdditionalServices = 'additionalServices',
  SALT = 'SALT',
  FILTER = 'FILTER',
  VIVO = 'VIVO',
  ENDO = 'ENDO',
  HPLC = 'HPLC',
  DESALT = 'DESALT',
  ReviewWarning = 'ReviewWarning',
  OTHER_VALUE = 'otherValue',
  Sequence = 'sequence',
  AntiSenseSequence = 'antisenceSequence',
}

export enum Modification {
  FiveMod = 'fiveMod',
  ThreeMod = 'threeMod',
  NTerminalMod = 'nterminalMod',
  CTerminalMod = 'cterminalMod',
  QuencherMod = 'reporterQuencher',
  InternalMod = 'internalMod',
  DefaultRnaMod = '[None]',
  ModFive = 'fivemod',
  QuencherMOD = 'modification',
  CTerminal = 'cterminal',
  NTerminal = 'nterminal',
  Fivemod = 'fivemod',
  Threemod = 'threemod',
  FiveModThreeMod = 'fiveModThreeMod',
  LabeledAminoAcid = 'labeledAminoAcids',
  OptionalBase = 'degenerateBases',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
}
export enum CountryType {
  cpeptideJapan = 'JP',
  cpeptideIsrael = 'IL',
}

export enum ProductUploadType {
  TubePCRUpload = 'PCR Oligos_Quick Entry',
  TubeRNAOligo = 'RNA Oligos ',
  EasyOligos = 'Easy Oligos',
  TubeDNAUpload = 'DNA Oligos in Tubes',
  Probes = 'Dual Labeled Probes',
  Aqua = 'AQUA Peptides',
  Wellred = 'WellRED Oligos',
  Beacons = 'Molecular Beacons',
  PureSimple = 'Pure and Simple',
  CustomPeptides = 'Custom Peptides',
  IscaleDna = 'iScale DNA Oligo',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}

export enum Purification {
  Cartridge = 'RP1',
  FiveAmount = '5 OD',
  PointFiveAmount = '0.5 OD',
  HPLC = 'HPLC',
  PAGE = 'PAGE',
}

export enum UploadType {
  copyPaste = 'copyPaste',
  fileUpload = 'fileUpload',
  prodType = 'tube',
}

export enum StartRow {
  standard = 6,
  rna = 7,
  aqua = 21,
  wellred = 8,
  PROBE = 8,
  cpeptide = 5,
  BEACON = 8,
  easyoligo = 10,
  puresimple = 9,
  longoligo = 10,
  iscaledna = 6,
}

export enum probeTypes {
  DualLabel = 'duallabel',
  Default = 'default',
  InternalQuench = 'internalquench',
  DualQuench = 'dualquench',
}
